import React from 'react';
import {
  Dialog,
  DialogContent,
  Typography,
  Button,
  Box,
  useTheme,
  useMediaQuery
} from '@mui/material';
import { formatDateWithTime } from '../../utils/patientUtils';

// Shown on a 409 from POST /api/reports/feedback/{uuid}/ - another Ophthalmologist in the
// same district already submitted feedback for this report. No retry: a retry 409s forever.
const FeedbackConflictModal = ({ open, onAcknowledge, submittedBy, submittedAt }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <Dialog
      open={open}
      onClose={() => {}} // Do nothing on backdrop click or escape key - must use the OK button
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: '12px',
          padding: isMobile ? '20px' : '32px',
          width: isMobile ? '85vw' : '400px',
          height: 'auto',
          maxWidth: isMobile ? '85vw' : '400px',
          margin: isMobile ? '16px' : 'auto',
          boxShadow: '0px 8px 32px rgba(0, 0, 0, 0.12)',
          border: 'none'
        }
      }}
    >
      <DialogContent sx={{ padding: 0, textAlign: 'center' }}>
        <Box sx={{ marginBottom: isMobile ? '20px' : '24px', marginTop: isMobile ? '8px' : '0px' }}>
          <Box
            sx={{
              width: isMobile ? '64px' : '72px',
              height: isMobile ? '64px' : '72px',
              borderRadius: '50%',
              border: `${isMobile ? '3px' : '4px'} solid #051572`,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              margin: '0 auto',
              backgroundColor: '#FFF',
              boxShadow: '0px 2px 8px rgba(5, 21, 114, 0.15)'
            }}
          >
            <Typography
              sx={{
                fontSize: isMobile ? '32px' : '36px',
                fontWeight: 'bold',
                color: '#051572'
              }}
            >
              i
            </Typography>
          </Box>
        </Box>

        <Typography
          variant={isMobile ? 'h6' : 'h5'}
          component="div"
          sx={{
            fontWeight: 600,
            marginBottom: isMobile ? '16px' : '20px',
            color: '#1a1a1a',
            fontSize: isMobile ? '20px' : '24px'
          }}
        >
          Feedback Already Submitted
        </Typography>

        <Typography
          sx={{
            fontSize: isMobile ? '14px' : '16px',
            color: '#666666',
            marginBottom: isMobile ? '24px' : '28px',
            lineHeight: 1.5,
            paddingX: isMobile ? '4px' : '8px',
            fontWeight: 400
          }}
        >
          Dr. {submittedBy} already submitted feedback for this patient at{' '}
          <span style={{ fontWeight: 600, color: '#1a1a1a' }}>
            {formatDateWithTime(submittedAt)}
          </span>
          . Your feedback was not saved.
        </Typography>

        <Button
          onClick={onAcknowledge}
          variant="contained"
          sx={{
            borderRadius: '8px',
            backgroundColor: '#051572',
            color: '#FFF',
            padding: isMobile ? '8px 12px' : '10px 20px',
            fontSize: isMobile ? '13px' : '15px',
            fontWeight: 600,
            textTransform: 'none',
            minWidth: isMobile ? '48%' : '170px',
            height: '40px',
            boxShadow: '0px 2px 8px rgba(5, 21, 114, 0.25)',
            '&:hover': {
              backgroundColor: '#041461',
              boxShadow: '0px 4px 12px rgba(5, 21, 114, 0.35)'
            }
          }}
        >
          OK
        </Button>
      </DialogContent>
    </Dialog>
  );
};

export default FeedbackConflictModal;
